import { cn } from '@lib/cn'
import React, { FC } from 'react'

export interface Icons {
  'caret-down': React.ReactElement
  'chevron-left': React.ReactElement
  'chevron-right': React.ReactElement
  'rolex-refresh-arrow': React.ReactElement
  'rolex-caret-down': React.ReactElement
  'rolex-mobile-menu-arrow': React.ReactElement
  'rolex-back-to-top-arrow': React.ReactElement
  info: React.ReactElement
  mail: React.ReactElement
  phone: React.ReactElement
  location: React.ReactElement
  'close-map-location': React.ReactElement
  directions: React.ReactElement
  externalLink: React.ReactElement
  plus: React.ReactElement
  minus: React.ReactElement
  whatsapp: React.ReactElement
}

export const icons: Icons = {
  'rolex-refresh-arrow': (
    <path
      d="M3.42615 14.9301H0L4.34883 19.5143L8.58796 14.9301H5.16181C5.2715 13.2391 5.68122 11.8025 6.38129 10.289C7.08781 8.76537 7.97822 7.46612 9.08801 6.36779C10.1978 5.26945 11.4979 4.41891 12.9981 3.77598C14.4853 3.13975 16.0468 2.80824 17.676 2.80824C19.9439 2.80824 22.0571 3.39424 23.996 4.57964C25.922 5.75834 27.4544 7.36901 28.5803 9.38821C29.7062 11.4074 30.2708 13.6074 30.2708 15.9849C30.2708 18.3624 29.7127 20.5825 28.5803 22.6151C27.4544 24.6377 25.922 26.2484 23.9927 27.4237C22.0538 28.6091 19.9407 29.1951 17.6727 29.1951C15.7177 29.1951 13.8401 28.7196 12.0722 27.782L11.3366 29.4563C13.3852 30.491 15.4983 31 17.6727 31C19.6117 31 21.4699 30.5982 23.2411 29.8012C25.0057 29.0076 26.5414 27.9461 27.8254 26.6C29.0933 25.2706 30.1159 23.68 30.8741 21.8249C31.6322 19.9731 32 18.0175 32 15.9816C32 13.9456 31.6322 12.0068 30.8741 10.155C30.1127 8.29657 29.0933 6.70265 27.8254 5.37995C26.5478 4.04722 25.0057 2.99241 23.2411 2.19545C21.4731 1.40183 19.6149 1 17.676 1C15.1886 1 12.8916 1.62619 10.7624 2.87186C8.62022 4.12423 6.89747 5.82532 5.60056 7.97511C4.30043 10.1249 3.56488 12.3517 3.42615 14.9301Z"
      fill="currentColor"
    />
  ),
  'caret-down': <path d="M8 0H0L4 5L8 0Z" fill="currentColor" />,
  'chevron-left': (
    <path
      d="M14.5746 16L20 10.7346L18.2127 9L11 16L18.2127 23L20 21.2654L14.5746 16Z"
      fill="currentColor"
    />
  ),
  'chevron-right': (
    <path
      d="M16.4254 16L11 21.2654L12.7873 23L20 16L12.7873 9L11 10.7346L16.4254 16Z"
      fill="currentColor"
    />
  ),
  'rolex-caret-down': <path d="M8 0H0L4 5L8 0Z" fill="currentColor" />,
  'rolex-mobile-menu-arrow': (
    <path
      d="M16 16.6169L12.239 13L11 14.1915L16 19L21 14.1915L19.761 13L16 16.6169Z"
      fill="currentColor"
    />
  ),
  'rolex-back-to-top-arrow': (
    <path
      d="M16 13.5746L21.2654 19L23 17.2127L16 10L9 17.2127L10.7346 19L16 13.5746Z"
      fill="currentColor"
    />
  ),
  info: (
    <>
      <g transform="translate(8.5, 8.5)">
        <path
          d="M7.5 0C3.4 0 0 3.4 0 7.5S3.4 15 7.5 15 15 11.6 15 7.5 11.6 0 7.5 0zm0 14.1c-3.6 0-6.6-3-6.6-6.6s3-6.6 6.6-6.6 6.6 3 6.6 6.6-2.5 6.6-6.6 6.6z"
          fill="currentColor"
        />
        <path
          d="M8.4 10.3c-.1.2-.3.4-.5.6-.1.1-.4.1-.4-.1l1.8-5.1h-3L6 6.6h1.2L6 10.1l-.3.8c-.1.3-.1.5 0 .8.3.5.9.5 1 .5s.4 0 .8-.2c.7-.4 1.2-1 1.4-1.4"
          fill="currentColor"
        />
        <circle cx="8.5" cy="3.8" r="1" fill="currentColor" />
      </g>
    </>
  ),
  mail: (
    <>
      <path
        d="M24.2422 8.38281H7.75782C7.48723 8.38281 7.23391 8.44934 7.00473 8.55898L15.9609 17.5152L17.9683 15.586C17.9683 15.586 17.9685 15.5858 17.9685 15.5857C17.9686 15.5857 17.9687 15.5856 17.9687 15.5856L24.9956 8.55914C24.7663 8.44941 24.5129 8.38281 24.2422 8.38281Z"
        fill="currentColor"
      />
      <path
        d="M25.8241 9.38782L19.2114 16.0001L25.8238 22.6125C25.9335 22.3833 26 22.13 26 21.8594V10.1406C26 9.8702 25.9336 9.61692 25.8241 9.38782Z"
        fill="currentColor"
      />
      <path
        d="M6.17617 9.38757C6.06652 9.61675 6 9.87007 6 10.1407V21.8594C6 22.1298 6.06645 22.3832 6.17602 22.6123L12.7886 16L6.17617 9.38757Z"
        fill="currentColor"
      />
      <path
        d="M18.3829 16.8287L16.3752 18.7581C16.2608 18.8726 16.1109 18.9298 15.961 18.9298C15.8111 18.9298 15.6611 18.8726 15.5467 18.7581L13.6172 16.8286L7.00446 23.4409C7.23367 23.5506 7.48715 23.6172 7.75781 23.6172H24.2422C24.5128 23.6172 24.7661 23.5507 24.9953 23.4411L18.3829 16.8287Z"
        fill="currentColor"
      />
    </>
  ),
  phone: (
    <path
      d="M25.6111 21.9032L23.3939 20.4249L21.4229 19.1112C21.0425 18.8581 20.5313 18.9411 20.2505 19.3015L19.0308 20.8694C18.7688 21.2097 18.2976 21.3074 17.9219 21.0994C17.0943 20.6391 16.1157 20.2057 13.9564 18.0436C11.7971 15.8816 11.3609 14.9057 10.9006 14.0781C10.6926 13.7024 10.7903 13.2312 11.1306 12.9692L12.6985 11.7496C13.0589 11.4688 13.1419 10.9576 12.8888 10.5772L11.6154 8.66684L10.0968 6.3889C9.8383 6.00117 9.32088 5.88477 8.92128 6.12441L7.16989 7.1751C6.69658 7.45397 6.34865 7.90427 6.19818 8.43267C5.71924 10.1789 5.62268 14.0309 11.7961 20.2042C17.9694 26.3776 21.8211 26.2807 23.5673 25.8018C24.0957 25.6513 24.546 25.3034 24.8249 24.83L25.8756 23.0787C26.1152 22.6791 25.9988 22.1617 25.6111 21.9032Z"
      fill="currentColor"
    />
  ),
  location: (
    <path
      d="M15.6667 6C11.9907 6 9 8.99074 9 12.6667C9 13.7702 9.2759 14.8643 9.80039 15.8348L15.3021 25.7852C15.3754 25.9178 15.5149 26 15.6667 26C15.8184 26 15.958 25.9178 16.0312 25.7852L21.535 15.8315C22.0575 14.8643 22.3334 13.7702 22.3334 12.6666C22.3334 8.99074 19.3426 6 15.6667 6ZM15.6667 16C13.8287 16 12.3334 14.5046 12.3334 12.6667C12.3334 10.8287 13.8287 9.33336 15.6667 9.33336C17.5046 9.33336 19 10.8287 19 12.6667C19 14.5046 17.5046 16 15.6667 16Z"
      fill="currentColor"
    />
  ),
  'close-map-location': (
    <path
      d="M16 15.1544L22.1544 9L23 9.8456L16.8456 16L23 22.1544L22.1544 23L16 16.8456L9.8456 23L9 22.1544L15.1544 16L9 9.8456L9.8456 9L16 15.1544Z"
      fill="currentColor"
    />
  ),
  directions: <path d="M6 16H16V26H17.1L26 6L6 14.9V16Z" fill="currentColor" />,
  externalLink: (
    <>
      <path
        d="M17.9375 25.125H6.4375V7.875H17.9375V10.75H19.375V7.875V6.4375H17.9375H6.47344H5.03594H5V7.875V25.125V26.5625H19.375V25.125V22.25H17.9375V25.125Z"
        fill="currentColor"
      />
      <path
        d="M25.8438 14.3438L23.6875 12.1875V15.7812H12.1875V17.2188H23.6875V20.8125L25.8438 18.6562L28 16.5L25.8438 14.3438Z"
        fill="currentColor"
      />
    </>
  ),
  plus: (
    <path
      d="M18.1429 17.7857C17.9456 17.7857 17.7857 17.9456 17.7857 18.1429V26H14.2143V18.1429C14.2143 17.9456 14.0544 17.7857 13.8571 17.7857H6V14.2143H13.8571C14.0544 14.2143 14.2143 14.0544 14.2143 13.8571V6H17.7857V13.8571C17.7857 14.0544 17.9456 14.2143 18.1429 14.2143H26V17.7857H18.1429Z"
      fill="currentColor"
    />
  ),
  minus: (
    <path
      d="M18.1429 17.7858C15.9201 17.7858 15.0307 17.7858 13.8571 17.7858H6V14.2143H13.8571C15.2761 14.2143 17.0392 14.2143 18.1429 14.2143H26V17.7858H18.1429Z"
      fill="currentColor"
    />
  ),
  whatsapp: (
    <path
      d="M16.0027 5H15.9973C9.93213 5 5 9.9335 5 16C5 18.4062 5.7755 20.6365 7.09413 22.4474L5.72325 26.5339L9.95138 25.1823C11.6908 26.3345 13.7656 27 16.0027 27C22.0679 27 27 22.0651 27 16C27 9.93488 22.0679 5 16.0027 5ZM22.4034 20.5334C22.138 21.2827 21.0847 21.9042 20.2446 22.0857C19.6699 22.2081 18.9191 22.3058 16.3919 21.258C13.1592 19.9188 11.0775 16.6339 10.9153 16.4207C10.7599 16.2076 9.609 14.6814 9.609 13.1029C9.609 11.5244 10.4106 10.7558 10.7338 10.4258C10.9991 10.1549 11.4377 10.0311 11.8585 10.0311C11.9946 10.0311 12.117 10.038 12.227 10.0435C12.5501 10.0572 12.7124 10.0765 12.9255 10.5866C13.1909 11.226 13.8371 12.8045 13.9141 12.9668C13.9925 13.129 14.0709 13.349 13.9609 13.5621C13.8578 13.7821 13.767 13.8797 13.6047 14.0667C13.4425 14.2537 13.2885 14.3968 13.1262 14.5975C12.9777 14.7721 12.81 14.9591 12.997 15.2823C13.184 15.5985 13.8302 16.6531 14.7817 17.5001C16.0096 18.5932 17.0051 18.9425 17.3612 19.091C17.6266 19.201 17.9429 19.1749 18.1367 18.9686C18.3829 18.7033 18.6867 18.2633 18.9961 17.8301C19.2161 17.5194 19.4939 17.4809 19.7854 17.5909C20.0824 17.694 21.654 18.4709 21.9771 18.6317C22.3003 18.794 22.5134 18.871 22.5917 19.0071C22.6687 19.1433 22.6687 19.7826 22.4034 20.5334Z"
      fill="currentColor"
    />
  ),
}

type Props = {
  icon: keyof Icons
  className?: string
}

export const Icon: FC<Props> = ({ icon, className, ...rest }) => {
  return icons[icon] ? (
    <svg viewBox="0 0 32 32" className={cn('h-8 w-8', className)} {...rest}>
      {icons[icon]}
    </svg>
  ) : null
}
